import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { CUSTOMER_PATH } from '../../core/constants';
import { buildQueryString, extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const getCustomerBlockadeHistoryRegistriesAction = createAsyncThunk(
    'customer/getCustomerBlockadeHistoryRegistriesAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(`${ CUSTOMER_PATH }/${ data.customerId }/blockade-history-registries${ buildQueryString(data.queryParams) }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getCustomerBlockadeHistoryRegistriesSlice = createSlice({
    name: 'getCustomerBlockadeHistoryRegistriesSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getCustomerBlockadeHistoryRegistriesAction.pending, () => STATE__API__STARTED);
        builder.addCase(getCustomerBlockadeHistoryRegistriesAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getCustomerBlockadeHistoryRegistriesAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const getCustomerBlockadeHistoryRegistriesState = (state) => state.customer.getCustomerBlockadeHistoryRegistries;
export default getCustomerBlockadeHistoryRegistriesSlice.reducer;